import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import VueApexCharts from 'vue-apexcharts'

Vue.config.productionTip = false

Vue.prototype.$apiPath1 = 'https://exhib.api.ticketgenie.in/Exhibitions/';



  Vue.prototype.$apiPath = 'https://accred.api.dnanetworks.in/';
 //Vue.prototype.$apiPath = 'https://arsw.api.dnanetworks.in/';

 //http://arsw.api.dnanetworks.in

 //Vue.prototype.$apiPath = 'https://localhost:44319/';


Vue.prototype.$aKey = "ticketgenieapikey";


Vue.use(VueApexCharts)
 
Vue.component('apexchart', VueApexCharts)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
